module.exports = __webpack_public_path__ + "static/media/phoebe_img.a4aeced5.svg";